import * as React from 'react';
import { formatMoney } from '../../utils/string';
import * as styles from './BalanceMobile.css';
import { IBalanceMobileProps } from './types';

export const BalanceMobile = (props: IBalanceMobileProps) => {
  const { balance } = props;

  return (
    <div className={styles['balance_wrapper']}>
      <div>Баланс: {formatMoney(balance)}</div>
    </div>
  );
};
